/** Normaliza fulfillment de producto/pedido para operación admin. */
export function normalizeFulfillment(value) {
  const f = String(value || '').trim().toLowerCase();
  if (['dropshipping', 'supplier', 'proveedor'].includes(f)) {
    return 'dropshipping';
  }
  return 'javiland';
}

export function isDropshipping(value) {
  return normalizeFulfillment(value) === 'dropshipping';
}

export function fulfillmentLabel(value) {
  return isDropshipping(value) ? 'Dropshipping' : 'Bodega Chía';
}

export function fulfillmentSummaryLabel(summary) {
  if (summary === 'mixed') return 'Mixto';
  return fulfillmentLabel(summary);
}

function formatShippingAddressForWhatsApp(order) {
  const legacy = order.shipping_address != null ? String(order.shipping_address).trim() : '';
  const line1 = order.shipping_address_line1 != null ? String(order.shipping_address_line1).trim() : '';
  const line2 = order.shipping_address_line2 != null ? String(order.shipping_address_line2).trim() : '';
  const city = order.shipping_city != null ? String(order.shipping_city).trim() : '';
  const dept = order.shipping_department != null ? String(order.shipping_department).trim() : '';
  const zip =
    order.shipping_zip_code != null
      ? String(order.shipping_zip_code).trim()
      : order.shipping_postal_code != null
        ? String(order.shipping_postal_code).trim()
        : '';

  const streetParts = [line1 || legacy, line2].filter(Boolean);
  const street = streetParts.join(', ');

  const locationParts = [city, dept, zip].filter(Boolean);
  if (!street) {
    return locationParts.length ? locationParts.join(', ') : '—';
  }

  const streetLower = street.toLowerCase();
  const extra = locationParts.filter((part) => !streetLower.includes(String(part).toLowerCase()));
  return extra.length ? `${street}, ${extra.join(', ')}` : street;
}

export function buildDropshipWhatsAppMessage(order) {
  const items = (order.items || []).filter((line) => isDropshipping(line.fulfillment));
  const productLines = items.length
    ? items.map((line) => `• ${line.quantity}x ${line.product_name}`).join('\n')
    : '• (sin productos de proveedor en esta orden)';

  const address = formatShippingAddressForWhatsApp(order);

  return [
    'Hola, nuevo pedido Javiland:',
    '',
    `Orden: ${order.order_number || `#${order.id}`}`,
    `Cliente: ${order.customer_name || '—'}`,
    `Email: ${order.customer_email || '—'}`,
    `Tel: ${order.customer_phone || '—'}`,
    '',
    'Productos:',
    productLines,
    '',
    'Enviar a:',
    address,
    '',
    'Gracias.'
  ].join('\n');
}
